import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { PropertiesTax } from 'src/common-services'
import { Flex, FlexColumn } from 'src/components/flex-containers'
import { PropertyRecordAccordion } from 'src/components/insights/property-records/property-record-accordion'
import { Grid, Typography } from '@mui/material'
import { formatVal } from 'src/utils/number-format'
import { GridPairKey, GridPairValue } from 'src/components/grid-pair'
import { UnavailableCardContent } from 'src/components/insights/unavailable-card-content'

const Wrapper = styled(FlexColumn)`
  gap: ${Shapes.spacing[4]}px;
  padding-inline: ${Shapes.spacing[4]}px;
`

const SectionContent = styled(Flex)`
  gap: ${Shapes.spacing[4]}px;
`
const SectionColumn = styled(FlexColumn)`
  padding-right: ${Shapes.spacing[4]}px;
  border-right: 1px solid ${Colors.border};
  .MuiGrid-item {
    padding-bottom: ${Shapes.spacing[4]}px;
  }
  &:last-of-type {
    border-right: none;
  }
`

const Tax = (props: { tax: PropertiesTax }) => {
  const { tax } = props

  return (
    <PropertyRecordAccordion
      title={
        <Typography variant="textmd" color={Colors.textBlack}>
          Tax Year: {tax.taxYear || '-'}
        </Typography>
      }
      content={
        <SectionContent>
          <SectionColumn
            style={{
              flex: 1,
            }}>
            <Grid container>
              <GridPairKey>Tax Amount</GridPairKey>
              <GridPairValue>{formatVal(tax.taxAmount, 'currency-expanded') || '-'}</GridPairValue>
              <GridPairKey>Assessed Land Value</GridPairKey>
              <GridPairValue>{formatVal(tax.assessedLandValue, 'currency-expanded') || '-'}</GridPairValue>
              <GridPairKey>Assessed Improvement Value</GridPairKey>
              <GridPairValue>{formatVal(tax.assessedImprovementsValue, 'currency-expanded') || '-'}</GridPairValue>
              <GridPairKey>Total Assessed Value</GridPairKey>
              <GridPairValue>{formatVal(tax.totalAssessedValue, 'currency-expanded') || '-'}</GridPairValue>
            </Grid>
          </SectionColumn>
          <SectionColumn
            style={{
              flex: 1,
            }}>
            <Grid container>
              <GridPairKey>Land Market Value</GridPairKey>
              <GridPairValue>-</GridPairValue>
              <GridPairKey>Improvements Market Value</GridPairKey>
              <GridPairValue>{formatVal(tax.improvementsMarketValue, 'currency-expanded') || '-'}</GridPairValue>
              <GridPairKey>Total Market Value</GridPairKey>
              <GridPairValue>{formatVal(tax.totalMarketValue, 'currency-expanded') || '-'}</GridPairValue>
              <GridPairKey>Land Market Value</GridPairKey>
              <GridPairValue>{formatVal(tax.valueLand, 'currency-expanded') || '-'}</GridPairValue>
            </Grid>
          </SectionColumn>
        </SectionContent>
      }
    />
  )
}

export const PropertyRecordsDetailsTaxes = (props: { taxes: PropertiesTax[] }) => {
  const { taxes } = props

  if (!taxes.length) {
    return <UnavailableCardContent message="No taxes found" />
  }

  return (
    <Wrapper>
      {taxes.map((tax, index) => {
        return <Tax key={index + 'tax'} tax={tax} />
      })}
    </Wrapper>
  )
}
